// Object that enumerates all possible surfaces an in-product notification can appear on.
// Maintaining this enumeration helps create a shared understanding of where IPNs may be rendered and ensures consistency across different IPN implementations.
// If you want to update this enumeration, reach out to the Shared Services team.
export const IPN_SURFACE = {
  DASHBOARD: 'dashboard',
  DASHBOARD_ACTIVITY: 'dashboard/activity',
  DASHBOARD_ACCEPT_GUEST_INVITATION: 'dashboard/accept-guest-invitation',
  DASHBOARD_APPS_AND_INTEGRATION_DEVELOP:
    'dashboard/apps-and-integration/develop',
  DASHBOARD_PLANS: 'dashboard/plans',
  DASHBOARD_TEAM: 'dashboard/team',
  DASHBOARD_TEAM_GUESTS: 'dashboard/team/guest-members',
  DESIGNER: 'designer',
  MARKETPLACE: 'marketplace',
} as const;

export type IpnSurface = (typeof IPN_SURFACE)[keyof typeof IPN_SURFACE];
